import { render, staticRenderFns } from "./UpdatedBisTable.vue?vue&type=template&id=5ab9ce17&"
import script from "./UpdatedBisTable.vue?vue&type=script&lang=js&"
export * from "./UpdatedBisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports